// src/utils/referenceDataUpdater.ts
import store from "@core/store"
import { fetchMemberPublicDoctors } from "@core/api/doctorApi"
import { fetchSugas } from "@core/api/sugaApi"
import { fetchPharmaComplex } from "@core/api/pharmaComplexApi"
import { fetchPharmaSimple } from "@core/api/pharmaSimpleApi"
import { fetchPublicBuhangcup } from "@core/api/hospitalApi"
import { fetchDepartments } from "@core/api/departmentApi"
import { fetchVisitrouts } from "@core/api/visitrouteApi"
import { fetchUninsuredItems, fetchUninsuredCategory } from "@core/api/uninsuredApi"
import { fetchPublicHospitalInfo } from "@core/api/hospitalApi"
import { fetchExistPharmacyListThunk } from "@/features/pharmacy/pharmacySlice"
import { fetchBuhangcups } from "@core/api/buhangcupApi"
import { getAcupointsData } from "@core/api/acupointApi"
import { AcupointConstants } from "@core/constants/AcupointConstants"
import { fetchPublicStamp } from "@/features/stamp/stampSlice"
import { getReferenceTaCompanies } from "@core/api/taCompanyApi"
import { setInsuranceCompanyOptions } from "@/types/insuranceCompany"
import { setBroadcast } from "@/features/broadcast/broadcastSlice"

export const handleReferenceUpdate = async (reference: string) => {
  console.debug("참조 데이터 업데이트 수신:", reference)

  const dispatch = store.dispatch

  const syncTaCompanies = async () => {
    try {
      const taCompanies = await getReferenceTaCompanies()
      setInsuranceCompanyOptions(taCompanies)
    } catch (error) {
      console.warn("보험사 기준코드(reference/ta_company) 로드 실패, fallback 사용:", error)
    }
  }

  switch (reference) {
    case "all":
      // 전체
      await syncTaCompanies()
      dispatch(fetchPublicHospitalInfo())
      dispatch(fetchMemberPublicDoctors())
      dispatch(fetchSugas())
      dispatch(fetchPharmaComplex())
      dispatch(fetchPharmaSimple())
      dispatch(fetchBuhangcups())
      dispatch(fetchPublicBuhangcup())
      dispatch(fetchDepartments())
      dispatch(fetchVisitrouts())
      dispatch(fetchUninsuredCategory())
      dispatch(fetchUninsuredItems())
      dispatch(fetchExistPharmacyListThunk("herbal_medicine"))
      dispatch(fetchExistPharmacyListThunk("acupuncture_preparation"))
      dispatch(fetchExistPharmacyListThunk("other"))
      break
    case "initial":
      // legacy
      await syncTaCompanies()
      dispatch(fetchSugas())
      dispatch(fetchPharmaComplex())
      dispatch(fetchPharmaSimple())
      dispatch(fetchBuhangcups())
      dispatch(fetchPublicBuhangcup())
      dispatch(fetchDepartments())
      dispatch(fetchVisitrouts())
      dispatch(fetchUninsuredCategory())
      dispatch(fetchUninsuredItems())
      dispatch(fetchExistPharmacyListThunk("herbal_medicine"))
      dispatch(fetchExistPharmacyListThunk("acupuncture_preparation"))
      dispatch(fetchExistPharmacyListThunk("other"))
      break
    case "login":
      // 로그인 성공하면
      await syncTaCompanies()
      // dispatch(fetchPublicHospitalInfo())
      dispatch(fetchMemberPublicDoctors())
      dispatch(fetchDepartments())
      dispatch(fetchExistPharmacyListThunk("herbal_medicine"))
      dispatch(fetchExistPharmacyListThunk("acupuncture_preparation"))
      dispatch(fetchExistPharmacyListThunk("other"))
      break
    case "background":
      // 인증 완료 후 1회 백그라운드 초기 로드.
      await syncTaCompanies()
      dispatch(fetchMemberPublicDoctors())
      dispatch(fetchSugas())
      dispatch(fetchPharmaComplex())
      dispatch(fetchPharmaSimple())
      dispatch(fetchBuhangcups())
      dispatch(fetchPublicBuhangcup())
      dispatch(fetchDepartments())
      dispatch(fetchVisitrouts())
      dispatch(fetchUninsuredCategory())
      dispatch(fetchUninsuredItems())
      dispatch(fetchPublicStamp())
      // 경혈 데이터 로드 (서버에서 가져와서 AcupointConstants에 설정)
      try {
        // console.debug("경혈 데이터 로드 시작")
        const serverAcupoints = await getAcupointsData()
        AcupointConstants.setServerData(serverAcupoints)
        const status = AcupointConstants.getStatus()
        // console.debug("경혈 데이터 로드 완료:", status)
      } catch (error) {
        console.warn("경혈 데이터 로드 실패, 기본값 사용:", error)
        const status = AcupointConstants.getStatus()
        console.debug("경혈 데이터 기본값 사용:", status)
        // 실패해도 기본값을 사용하므로 에러를 던지지 않음
      }
      break
    case "buhangcup":
      dispatch(fetchPublicBuhangcup())
      break
    case "doctor":
      dispatch(fetchMemberPublicDoctors())
      break
    case "department":
      dispatch(fetchDepartments())
      break
    case "hospitalinfo":
      // console.debug("병원 정보 업데이트 요청")
      dispatch(fetchPublicHospitalInfo())
      break
    case "invoice_payment":
      dispatch(setBroadcast({ reference: reference }))
      // console.debug("수납 완료 브로드캐스트 설정:", reference)
      break
    case "pharma":
      dispatch(fetchPharmaComplex())
      dispatch(fetchPharmaSimple())
      break
    case "pharmacy":
      // console.debug("원외탕전 정보 업데이트 요청")
      dispatch(fetchExistPharmacyListThunk("herbal_medicine"))
      dispatch(fetchExistPharmacyListThunk("acupuncture_preparation"))
      dispatch(fetchExistPharmacyListThunk("other"))
      break
    case "visitroute":
      dispatch(fetchVisitrouts())
      break
    case "ta_company":
      await syncTaCompanies()
      break
    case "encounter_chuna":
      // 리덕스 추가
      // dispatch(fetchVisitrouts())
      break
  }
}

